// extracted by mini-css-extract-plugin
module.exports = {"auth":"AuthScreen_auth__1blck","card":"AuthScreen_card__zN6Na","body":"AuthScreen_body__A93MX","btn":"AuthScreen_btn__6hBby","icon":"AuthScreen_icon__1cpQe"};